import Header from '../pages/components/Header';
import Footer from '../pages/components/Footer';
import ModalOrcamento from '../pages/components/BudgetModal';
import WhatsappButton from '../pages/components/Whatsapp';
import Links from '../pages/Links';
import { useParams } from 'react-router-dom';

const Loader = () => {
    const { page } = useParams();
    
    const getPageComponent = () => {
        try {
            const PageComponent = require(`../pages/${page}`).default;
            return <PageComponent />;
        } catch (error) {
            console.error("Erro ao carregar a página:", error);
            return <h2>Página não encontrada</h2>;
        }
    };

    return (
        <>
            {page === 'links' ? (
                <Links />
            ) : (
                <>
                    <Header />
                    <ModalOrcamento />
                    {getPageComponent()}
                    <WhatsappButton />
                    <Footer />
                </>
            )}
        </>
    );
};

export default Loader;